<template>
  <!-- 数据集文件列表 -->
  <div class="dataset-file-list">
    <div class="list-head" v-if="datasetPageType == 2">
      <div>
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <!-- <el-checkbox v-model="selectCheckAll" @change="handleCheckAllChange">全选所有</el-checkbox> -->
      </div>
      <div class="add-button">
        <el-button type="primary" size="small" @click="addFile('0')">批量添加</el-button>
        <el-button type="primary" size="small" @click="addFile('1')">全部添加</el-button>   
      </div>
    </div>
    <div class="list-head" v-if="datasetPageType != 2 && searchType == 1">
      <div v-if="searchType == 1">
        <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange">全选</el-checkbox>
        <span @click="onBatchDelete">批量删除</span>
        <span @click="onDeleteAll">全部删除</span>
      </div>
      <div>
        <el-button class="upload-button" type="primary" size="small" @click="onCameraAcquisition()" v-if="searchType == 1 && (datasetType == 1 || datasetType == 2)">摄像头采集</el-button>
        <el-button class="upload-button" type="primary" size="small" @click="uploadPictures()" v-if="searchType == 1">{{`上传${modelTypeCompany(datasetType)}`}}</el-button>
      </div>
    </div>

    <div class="picture-box">
      <ul class="pictures">
        <li class="no-data" v-if="Pictures.records && Pictures.records.length === 0">
          <img :src="emptyImgUrl" alt="">
          <span>{{datasetPageType == 1 && searchType == 1 ? '当前无数据，开始上传吧~' : '当前无数据'}}</span>
        </li>
        <li
          class="picture-item"
          v-for="(item, idx) in Pictures.records"
          :key="idx"
        >
          <i :class="[
            'preview-icon', datasetType==1 || datasetType==2 ? 
            'icon-see-img': (datasetType==3 || datasetType==4 ? 
            'el-icon-full-screen':'icon-caret-preview')]"
            @click="onFilePreview(item.fileUrl)"
            title="预览"
          ></i>
          <figure>
            <img class="img" v-if="datasetType == 1 || datasetType == 2" :src="photoBaseUrl + item.fileUrl" alt="" />
            <img class="img-top" v-if="datasetType == 3 || datasetType == 4" src="../../../assets/images/txtImage@2x.png" alt="" />
            <img class="img-top" v-if="datasetType == 5 || datasetType == 6" src="../../../assets/images/audioImage@2x.png" alt="" />
          </figure>
          <div class="btns" v-if="datasetPageType != 2 && searchType == 1">
            <button
              class="btn-delete"
              @click="activeDeletePopup(item.fileId, idx)"
            >
              删除
            </button>
            <button
              class="btn-primary"
              @click="activeRenamePopup(item, idx)"
            >
              重命名
            </button>
          </div>
          <!-- 勾选框 -->
          <el-checkbox
            class="checkbox"
            v-model="item.checked"
            @change="handleChecked(item, idx)"
            v-if="datasetPageType != 2 && searchType == 1 || datasetPageType == 2"
          ></el-checkbox>
          <div class="title ellipsis" :title="item.fileName">
            {{ item.fileName }}
          </div>
        </li>
      </ul>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination
            @current-change="handleCurrentChange"
            background
            :current-page.sync="currentPage"
            :page-size="20"
            :pager-count="5"
            layout="slot, prev, pager, next"
            :total="Pictures.total"
          >
          </el-pagination>
      </div>
    </div>
    <!-- 弹窗集 -->
    <div class="popup-list">
      <!-- 上传图片提示 -->
      <model-training-upload-tips
        :modelType="datasetType"
        :popupActive="popupActive"
        @confirmUploadTip="confirmUploadTip"
        @cancelPopup="cancelPopup"
        @uploadNoTipChange="uploadNoTipChange"
      ></model-training-upload-tips>

      <!-- 删除 -->
      <gat-popup
        :class="[
          'popup-delete popup-delete-2',
          popupActive === 'delete' || popupActive === 'batch_delete' || popupActive === 'all_delete'
            ? 'on' : 'off',
        ]"
        :title="''"
        :primary-button="'删除'"
        @cancel="cancelPopup"
        @confirm="deleteOperate"
      >
        <template v-slot:content>
          <div class="popup-del-cnt">
            <div class="head">
              <i class="icon-box">
                <icon-base
                  class="icon-info-help"
                  :icon-name="Icons.InfoHelp.iconName"
                  v-bind="Icons.InfoHelp"
                >
                  <icon-info-help class="path-icon-info-help" />
                </icon-base>
              </i>
              <span v-show="popupActive === 'batch_delete'" class="title">
                {{`确定批量删除所选${modelTypeCompany(datasetType)}吗？`}}
              </span>
              <span v-show="popupActive === 'all_delete'" class="title">
                {{`确定删除数据集全部${modelTypeCompany(datasetType)}吗？`}}
              </span>
              <span v-show="popupActive === 'delete'" class="title">
                {{`确定删除此${modelTypeCompany(datasetType)}吗？`}}
              </span>
            </div>
          </div>
        </template>
      </gat-popup>

      <!-- 重命名 -->
      <gat-popup
        :class="['popup-rename', popupActive === 'rename' ? 'on' : 'off']"
        :title="'重命名'"
        @cancel="cancelPopup"
        @confirm="renameOperate"
      >
        <template v-slot:content>
          <el-input placeholder="请输入重命名" v-model.trim="popupData.rename.fileName" maxlength="20" show-word-limit />
        </template>
      </gat-popup>

      <!--文件预览-->
      <file-preview
        :modelType="datasetType"
        :fileUrl="fileUrl"
        :dialogvisibleview="dialogvisibleview"
        @onClickDialog="dialogvisibleview = false"
      ></file-preview>
    </div>
  </div>
</template>

<script>
import DATASETLOBBY from '@/axios/datasetLobby/datasetLobby.js'
import COMMON from "@/axios/common/common.js";
// import PRETRAIN from '@/axios/pretrain/pretrain.js'

import GatPopup from '@/components/common/GatPopup'
import IconInfoHelp from '@/components/icons/typography/InfoHelp'
import ModelTrainingUploadTips from '@/components/pretrain/ModelTrainingUploadTips.vue'
import FilePreview from '@/components/pretrain/FilePreview.vue'

import { GetVerifyImgs } from '@/assets/js/mixin/mixinGetVerifyImgs.js'

export default {
  name: "DatasetFileList",
  mixins: [GetVerifyImgs],
  components: { GatPopup, IconInfoHelp, ModelTrainingUploadTips, FilePreview },
  props: {
    // datasetidData: {
    //   type: Array,
    //   default: []
    // },
    // 数据页面类型：0数据大厅,1数据大厅详情，2引用数据集详情
    datasetPageType: {
      type: Number,
      default: null
    },
    searchType: {
      type: String,
      default: ''
    },
    datasetId: {
      type: String,
      default: ''
    },
    datasetName: {
      type: String,
      default: ''
    },
    datasetType: {
      type: String,
      default: '1'
    },
    modelDatasetId: {
      type: String,
      default: ''
    },
    labelId: {
      type: String,
      default: ''
    },
    modFileNum: {
      type: Number,
      default: 0
    },
  },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 新UC头像基地址
      modelType: '1',
      fileUrl: '',
      popupActive: '',
      selectCheckAll: false, // 全选所有
      checkAll: false, // 全选当前
      selectFileIdList: [],
      isIndeterminate: false, // 全选当前中间状态
      currentPage: 1, // 分页器当前页面
      Pictures: {
        records: [], // 文件列表
        size: 20,
        current: 1,
        total: 0,
      },
      imgPreviewUrl: '',
      dialogvisibleview: false,
      // 翻页
      pagination: {
        currentPage: 1,
        pageSize: 20,
        totalCount: 0,
        pagerCount: 5,
      },
      popupData: {
        rename: {
          index: -1,
          fileId: '',
          fileName: '',
        },
        uploadNoTip: false,
        delete: {
          index: -1,
        },
      },
      Icons: {
        InfoHelp: {
          iconName: '',
          viewBox: '0 0 36 36',
          width: '36',
          height: '36',
          // iconColor: "#fff"
        },
      },
      emptyImgUrl: require('../../../assets/images/datasetLobby/icon-empty-box.png'),
      formdata: new FormData(),
      clickFlag: false,
      modFileNumAll: 0,
    }
  },
  computed: {
  },
  watch: {
    'Pictures.records'(val) {
      this.handleCheckedAllState() // 勾选文件改变全部选框状态
    },
    selectFileIdList(val) {
      // console.log(val)
    },
    Pictures(val) {
      this.currentPage = val.current || 1;
    },
    modFileNum(num) {
      this.modFileNumAll = num || 0
    }
  },
  created() {
    // console.log('datasetPageType', this.datasetPageType)
    // 获取数据集文件列表
    this.getDatasetFileByDatasetId(1);
  },
  mounted() {},
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    // 获取数据集文件列表
    getDatasetFileByDatasetId(current) {
      let data = {
        datasetId: this.datasetId,
        datasetType: this.datasetType,
        pageNum: current ? current : 1,
        pageSize: this.Pictures.size,
      }
      DATASETLOBBY.getDatasetFileByDatasetId(data).then((result) => {
        if (result.isSuccess) {
          this.Pictures = result.data;
          this.Pictures.records.forEach(item => {
            item.checked = false;
          });
          this.$emit('getDatasetList'); // 刷新数据集列表
          // 当前页没有图片回调去到上一页
          if (this.Pictures && this.Pictures.current > 1 && this.Pictures.records.length === 0) {
            let currentPageNum = this.Pictures.current - 1;
            this.getDatasetFileByDatasetId(currentPageNum);
          }

          this.selectFileIdList = []; // 清空选中文件
        }
      })
    },

    // 变量初始状态
    initialState() {
      this.selectCheckAll = false // 全选所有
      this.checkAll = false // 全选当前页
      this.selectFileIdList = [] // 清空选中文件
      this.isIndeterminate = false // 取消全选中间状态
    },
    // 引用数据集添加文件
    addFile(val) {
      let list = [],
        fileNum = 0,
        type = val == 1 ? 1 : 0;

      if (val == 0 && this.selectFileIdList.length == 0) {
        return this.$message.error(`请先勾选需要添加的${this.modelTypeCompany(this.datasetType)}!`);
      }
      if (val == 1 && this.Pictures.records.length == 0) {
        return this.$message.error(`该数据集暂无${this.modelTypeCompany(this.datasetType)}!`);
      }

      if (val == 1) { // 全部添加
        fileNum = this.Pictures.total
      } else { // 批量添加
        list = this.selectFileIdList
        fileNum = list.length
      }

      // let modelType = this.datasetType,
      //   flagNum = modelType == 1 || modelType == 3 || modelType == 5 ? 200 : 3000;
      
      // if ((this.modFileNumAll + fileNum) > flagNum) {
      //   let msg =
      //     modelType == 1 || modelType == 3 || modelType == 5 ?
      //       `单个分类标签的${this.modelTypeCompany(modelType)}总数不超过 200个 ，请重新选择哦~` :
      //       `单个数据集的${this.modelTypeCompany(modelType)}总数不超过 3000个，请重新选择哦~`;
      //   return this.$message.error(msg)
      // }

      if (this.clickFlag) { // 判断连接点击多次只执行第一次
        return
      }
      this.clickFlag = true

      let data = {
        pubDatasetId: this.datasetId, // 当前数据集id
        pubDatasetName: this.datasetName, // 当前数据集名称
        datasetHallType: this.searchType, // 数据集大厅类型：0公开数据，1个人上传，2个人收藏
        datasetId: this.modelDatasetId, // 目标数据集id
        datasetType: this.datasetType, // 数据集类型
        labelId: this.labelId, // 分类标签id
        list: list, // 被引用的数据集id集合：全部添加传空，批量添加传文件id
        modFileNum: this.modFileNum, // 目标数据集文件数
        fileNum: fileNum, // 被引用的文件数量
        type: type, // 类型：0添加当前页，1添加所有
      }

      DATASETLOBBY.quoteDatasetFile(data).then((result) => {
        if (result.isSuccess) {
          this.$message.success(result.returnMsg)
          this.Pictures.records.forEach(item => {
            item.checked = false;
          });
          this.initialState(); // 变量初始状态
          this.modFileNumAll += fileNum
        } else {
          this.$message.error(result.returnMsg)
          if (result.returnCode == 501) { // 501：数据集不存在
            this.$emit('onBlackModel'); // 返回模型训练
          }
          if (result.returnCode == 502) { // 502：图片不存在
            this.$emit('getDatasetList') // 刷新数据集详情
            this.getDatasetFileByDatasetId(1); // 获取数据集文件列表
          }
        }
        setTimeout(() => {
          this.clickFlag = false
        }, 100);
      }).catch(() => {
        this.clickFlag = false
      });
    },

    // 全选、全不选
    handleCheckAllChange(val) {
      this.isIndeterminate = false;
      this.checkAll = val;
      // 判断只有一页的情况
      if (this.Pictures.total <= this.Pictures.size) {
        this.selectCheckAll = val; // 全选所有
      }

      let selectFileIdList = [];
      this.Pictures.records.forEach(item => {
        item.checked = val;
        selectFileIdList.push(item.fileId);
      });

      if (val) {
        this.selectFileIdList = selectFileIdList;
      } else {
        this.selectFileIdList = [];
      }
      this.$forceUpdate(); // 强制刷新数据
    },
    // 勾选文件改变全部选框状态
    handleCheckedAllState() {
      let checkedCount = 0;
      this.Pictures.records.forEach(item => {
        if (item.checked) {
          checkedCount++
        }
      });
      this.checkAll = this.Pictures.records.length && checkedCount === this.Pictures.records.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.Pictures.records.length;

      // 判断只有一页的情况
      if (this.Pictures.total <= this.Pictures.size) {
        if (this.checkAll) {
          this.selectCheckAll = this.checkAll
        } else if (checkedCount == 0) {
          this.selectCheckAll = this.checkAll
        }
      }
    },
    // 勾选框
    handleChecked(value, idx) {
      this.handleCheckedAllState() // 勾选文件改变全部选框状态

      // 选中文件添加到列表
      let flag = this.selectFileIdList.every((item, index) => {
        if (item === value.fileId) {
          this.selectFileIdList.splice(index, 1)
        }
        return item !== value.fileId
      })
      if (flag) {
        this.selectFileIdList.push(value.fileId)
      }
      this.$forceUpdate() // 强制刷新数据
    },

    // 摄像头采集
    onCameraAcquisition() {
      navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.msGetUserMedia;
      if(navigator.getUserMedia) {
        console.log("支持调取摄像头麦克风")

        let videoNum = 0;
        let microphoneNum = 0;
        navigator.mediaDevices.enumerateDevices().then(devices =>{
        	devices.forEach(device =>{
        		// console.log(device);
        		if (device.kind === "videoinput") { // 摄像头
              videoNum++
            };
        		if (device.kind === "audioinput") { // 麦克风
              microphoneNum++
            };
        	});
          // 检测是否有摄像头、麦克风
          if (videoNum) {
            this.$router.push({
              name: "camera-collection-img",
              query: {
                pageType: '2', // 页面类型：1模型训练，2数据集大厅
                modelType: this.datasetType,
                fileNumAll: this.Pictures.total,
                datasetId: this.datasetId,
              }
            })
          } else {
            this.$message.error('捕获摄像头失败，请重新安装摄像头！');
          }
        }).catch(function(err) {
          this.$message.error(err.name + ": " + err.message);
        });
      } else {
        this.$message.error('抱歉不支持调取摄像头');
      }
    },
    // 图片上传
    uploadPictures() {
      let datasetType = this.datasetType
      if (this.Pictures.total >= 200 && (datasetType == 1 || datasetType == 3 || datasetType == 5)) {
        return this.$message.error(`单个数据集所有${this.modelTypeCompany(datasetType)}总数不超过 200个`);
      }
      if (this.Pictures.total >= 3000 && (datasetType == 2 || datasetType == 4 || datasetType == 6)) {
        return this.$message.error(`单个数据集所有${this.modelTypeCompany(datasetType)}总数不超过 3000个`);
      }
      // TODO: 数据集选定、分类标签选定
      let uploadNoTip = window.localStorage.getItem(`__upload_tip_type${this.datasetType}__`);
      this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
      if (!this.popupData.uploadNoTip) {
        this.activeUploadTipPopup(); // 上传说明弹窗
      } else {
        this.uploadPicturesToDataset(); // 直接上传
      }
    },
    // 上传图片到相应标签的数据集中
    uploadPicturesToDataset() {
      var uploadFileNode = document.createElement('input'), // 创建上传按钮
        fileList = [], // 文件列表
        self = this,
        datasetType = self.datasetType;

      uploadFileNode.setAttribute('type', 'file'); // 设置上传按钮属性
      uploadFileNode.setAttribute('multiple', 'ture'); // 多文件上传
      if (datasetType == 1 || datasetType == 2) {
        uploadFileNode.setAttribute("accept", "image/jpeg, image/jpg"); // 限制图片除外的文件上传
      }
      if (datasetType == 3 || datasetType == 4) {
        uploadFileNode.setAttribute('accept', '.txt'); // 限制txt除外的文件上传
      }
      if (datasetType == 5 || datasetType == 6) {
        uploadFileNode.setAttribute('accept', '.mp3, .wav'); // 限制.mp3|.wav音频除外的文件上传
      }

      uploadFileNode.click(); // 触发上传事件

      // 上传进程
      uploadFileNode.onchange = function uploadChange(evt) {
        var formdata = new FormData(),
          list;

        // 文件装配
        fileList = evt.target.files;
        list = Array.from(fileList);

        // 限制单次上传数量
        if (list.length > 200) {
          return self.$message.error(`上传失败，单次上传${self.modelTypeCompany(datasetType)}限制200个!`);
        }
        if (self.Pictures.total + list.length > 200 && (datasetType == 1 || datasetType == 3 || datasetType == 5 )) {
          return self.$message.error(`上传失败，单个数据集所有${self.modelTypeCompany(datasetType)}总数不超过200个哦~`);
        }
        // 限制文件总数
        if (self.Pictures.total + list.length > 3000 && (datasetType == 2 || datasetType == 4 || datasetType == 6 )) {
          return self.$message.error(`上传失败，单个数据集所有${self.modelTypeCompany(datasetType)}总数不超过3000个哦~`);
        }

        self.fullscreenLoading = self.$loading({
          lock: true,
          text: `${self.modelTypeCompany(datasetType)}上传中请稍等...`,
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });

        // 图片
        if (datasetType == 1 || datasetType == 2) {
          self.noFile = 0;
          list.forEach((item, index) => {
            // self.selectUploadPicSize(item, list, index);
            let typeFlag = self.$util.filesFormatCheck(item, "jpg|jpeg"); // 检验文件类型
            if (typeFlag) {
              self.noFile++
              self.$message.error(`${item.name}上传失败，只允许上传 jpg/jpeg 格式图片！`);
            } else {
              formdata.append('file', item);
            }
          });
  
          if (list.length === self.noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
  
          self.UploadMultipleFileApi(formdata); // 上传图片接口调用
        }
        // 文本/音频
        if (datasetType == 3 || datasetType == 4 || datasetType == 5 || datasetType == 6) {
          let noFile = 0;
          list.forEach(async (file) => {
            if (datasetType == 3 || datasetType == 4) {
              let typeFlag = self.$util.filesFormatCheck(file, 'txt');
              if (typeFlag) {
                noFile++;
                self.$message.error(`${file.name}上传失败，请上传格式为txt的文件!`);
              } else if (file.size > 500 * 1024) {
                noFile++;
                self.$message.error(`上传失败，文件名称为${file.name}格式过大!`);
              } else {
                formdata.append('file', file);
              }
            }
            if (datasetType == 5 || datasetType == 6) {
              let typeFlag = self.$util.filesFormatCheck(file, 'mp3|MP3|wav|WAV');
              if (typeFlag) {
                noFile++;
                self.$message.error(`${file.name}上传失败，请上传格式为 wav/mp3 的音频!`);
              } else if (file.size > 5242880) {
                noFile++;
                self.$message.error(`上传失败，音频名称为${file.name}格式过大!`);
              } else {
                formdata.append('file', file);
              }
            }
          })
          if (list.length === noFile) {
            return self.fullscreenLoading.close(); // 关闭Loading
          }
          self.UploadMultipleFileApi(formdata) // 批量上传接口
        }
      }
    },
    // async selectUploadPicSize(ev, arrList, index) {
    //   var self = this;
    //   var uploadFile = ev;

    //   if (uploadFile) {
    //     if (window.FileReader) {
    //       var fr = new FileReader()
    //        fr.onloadend = await async function(e) {
    //         let typeFlag = self.$util.filesFormatCheck(uploadFile, "jpg|jpeg"); // 检验文件类型
    //         if (typeFlag) {
    //           self.noFile++
    //           self.$message.error(`${uploadFile.name}上传失败，只允许上传 jpg/jpeg 格式图片!`);
    //         } else {
    //           // 声明新Image
    //           var img = new Image()
    //           // 此处不做任何压缩直接读取文件流显示为图片（可扩展为压缩图片后显示）
    //           img.src = e.target.result
    //           img.onload = await function() {
    //             // 图片格式大小尺寸区间
    //             if (uploadFile.size > 4194304) {
    //               self.noFile++
    //               self.$message.error(`上传失败，图片名称为${uploadFile.name}格式过大!`);
    //             } else if (this.width > 2048 || this.height > 2048 ) {
    //               self.noFile++;
    //               self.$message.error(`上传失败，图片名称为“${uploadFile.name}”分辨率大于2048px*2048px!`);
    //             } else if (this.width < 64 || this.height < 64) {
    //               self.noFile++;
    //               self.$message.error( `上传失败，图片名称为“${uploadFile.name}”分辨率小于64px*64px!`);
    //             } else {
    //               self.formdata.append('file', uploadFile);
    //             }
    //           }
    //         }

    //         if (arrList.length === (index + 1)) {
    //           setTimeout(() => {
    //             if (arrList.length === self.noFile) {
    //               return self.fullscreenLoading.close(); // 关闭Loading
    //             }
    //             self.UploadMultipleFileApi(self.formdata) // 上传图片接口调用
    //           }, 1000);
    //         }
    //       }
    //       fr.readAsDataURL(uploadFile)
    //     }
    //   }
    // },
    // 上传图片接口调用
    UploadMultipleFileApi(formdata) {
      COMMON.UploadMultipleFile(formdata).then((result) => {
        // console.log('上传接口返回', result.data)
        if (result.returnCode == 200) {
          let dataList = JSON.parse(JSON.stringify(result.data));
          let imgList = [];
          let data = {
            datasetId: this.datasetId,
            datasetType: this.datasetType,
            list: []
          };

          if (this.datasetType == 1 || this.datasetType == 2) {
            dataList.forEach((item, index) => {
              // 图片格式大小尺寸区间
              if (item.size && item.size > 4194304) {
                setTimeout(() => {
                  this.$message.error(`上传失败，图片名称为${item.fileName}格式过大！`);
                }, index*5);
              } else if (item.width&&item.width > 2048 || item.height&&item.height > 2048 ) {
                setTimeout(() => {
                  this.$message.error(`上传失败，图片名称为“${item.fileName}”分辨率大于2048px*2048px！`);
                }, index*5);
              } else if (item.width&&item.width < 64 || item.height&&item.height < 64) {
                setTimeout(() => {
                  this.$message.error( `上传失败，图片名称为“${item.fileName}”分辨率小于64px*64px！`);
                }, index*5);
              } else {
                imgList.push(item);
              }
            });
  
            if (imgList.length === 0) {
              this.fullscreenLoading.close(); // 关闭Loading
              this.formdata = new FormData();  // 释放
              return
            }
  
            // 校验图片jpg|jpeg
            this.verifyImgs(imgList).then(res => {
              if (res.correct && res.correct.length) {
                res.correct.forEach(i => {
                  imgList.forEach(j => {
                    if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
                      data.list.push({
                        fileUrl: j.url,
                        fileName: j.fileName,
                        fileSize: j.size,
                        imgWidth: j.width,
                        imgHeight: j.height,
                      });
                    }
                  });
                });
                this.uploadImg(data); // 上传到服务器的文件转存到数据库中
              }
            })
          } else {
            data.list = dataList.map((item) => {
              return {
                fileName: item.fileName, // 文件名称
                fileUrl: item.url, // 文件url
                fileSize: item.size,
              }
            })
            this.uploadImg(data); // 上传到服务器的文件转存到数据库中
          }
        } else {
          this.$message.error(result.returnMsg);
          this.fullscreenLoading.close(); // 关闭Loading
        }
        this.formdata = new FormData(); // 释放
      }).catch((error)=>{
        this.formdata = new FormData(); // 释放
        this.fullscreenLoading.close(); // 关闭Loading
        this.$message.error('上传失败! 请检查网络是否正常或减少单次上传的文件数!');
      })
    },
    // 检验图片jpg|jpeg类型
    // verifyImgs(result) {
    //   let imgList = result.data;
    //   let params = {
    //     imgUrls: []
    //   };
    //   params.imgUrls = imgList.map((item) => {
    //     return {
    //       fileName: item.fileName, // 文件名称
    //       fileUrl: `${this.photoBaseUrl}${item.url}`, // 文件url
    //     }
    //   });
    //   COMMON.verifyImgs(params).then(res => {
    //     if (res.isSuccess) {
    //       if (res.data && res.data.correct && res.data.correct.length) {
    //         let data = {
    //           datasetId: this.datasetId,
    //           datasetType: this.datasetType,
    //           list: []
    //         }
    //         res.data.correct.forEach(i => {
    //           imgList.forEach(j => {
    //             if (i.fileUrl.indexOf(`${j.url}`) !== -1) {
    //               data.list.push({
    //                 fileUrl: j.url,
    //                 fileName: j.fileName,
    //                 fileSize: j.size,
    //                 imgWidth: j.width,
    //                 imgHeight: j.height,
    //               });
    //             }
    //           });
    //         });
    //         this.uploadImg(data); // 上传到服务器的文件转存到数据库中
    //       }
    //       if (res.data && res.data.error_info.length) {
    //         res.data.error_info.forEach((i, idx) => {
    //           setTimeout(() => {
    //             this.$message.error( `上传失败，图片名称为“${i.fileName}”只允许上传 jpg/jpeg 格式图片！`);
    //           }, idx*10);
    //         });
    //         if (imgList.length === res.data.error_info.length) {
    //           this.fullscreenLoading.close(); // 关闭Loading
    //         }
    //       }
    //     } else {
    //       this.fullscreenLoading.close(); // 关闭Loading
    //       this.$message.error('上传失败!');
    //     }
    //   }).catch((error)=>{
    //     this.fullscreenLoading.close(); // 关闭Loading
    //     this.$message.error('上传失败!');
    //   });
    // },
    // 存图片
    uploadImg(data) {
      // 上传到服务器的文件转存到数据库中
      DATASETLOBBY.uploadFileByDatasetId(data).then((result) => {
        if (result.isSuccess) {
          // 上传成功
          this.$message.success(result.returnMsg);
          this.fullscreenLoading.close(); // 关闭Loading
          // TODO:刷新数据
          this.getDatasetFileByDatasetId(1); // 文件列表
        } else {
          this.$message.error(result.returnMsg);
          this.fullscreenLoading.close(); // 关闭Loading
        }
      }).catch((error)=>{
        this.fullscreenLoading.close(); // 关闭Loading
      })
    },

    // 图片上传说明
    activeUploadTipPopup() {
      this.popupActive = 'uploadtip';
    },
    // 上传提示显示后再进行上传操作
    confirmUploadTip() {
      this.cancelPopup(); // 关闭弹窗
      // TODO:上传图片事件触发
      this.uploadPicturesToDataset();
    },
    // 上传图片
    uploadNoTipChange(val) {
      this.localStorageUploadTip('save', val);
    },
    // 图片上传说明是否显示存储
    localStorageUploadTip(type, value) {
      if (type === 'save') {
        this.popupData.uploadNoTip = value;
        window.localStorage.setItem(`__upload_tip_type${this.datasetType}__`, value);
      } else {
        let uploadNoTip = window.localStorage.getItem(`__upload_tip_type${this.datasetType}__`);
        this.popupData.uploadNoTip = uploadNoTip ? uploadNoTip : false;
      }
    },

    // 预览图片
    onFilePreview(imgUrl) {
      this.fileUrl = this.photoBaseUrl + imgUrl;
      this.dialogvisibleview = true;
    },
    // 批量删除
    onBatchDelete() {
      if (this.selectFileIdList.length === 0) {
        return this.$message.error(`请先勾选需要删除的${this.modelTypeCompany(this.datasetType)}！`);
      }
      this.popupActive = 'batch_delete'
    },
    // 全部删除
    onDeleteAll() {
      if (this.Pictures.records.length === 0) {
        return
      }
      this.popupActive = 'all_delete'
    },
    // 删除
    activeDeletePopup(fileId, index) {
      this.popupActive = 'delete';
      this.popupData.delete.index = index;
    },
    // 删除操作
    deleteOperate() {
      // 单删
      if (this.popupActive === 'delete') {
        let deleteIndex = this.popupData.delete.index,
          file = this.Pictures.records[deleteIndex],
          data = {
            datasetId: this.datasetId, // 数据集id
            datasetType: this.datasetType, // 数据集类型
            fileId: file.fileId, // 文件id
            fileName: file.fileName, // 文件名称
            fileSize: file.fileSize, // 文件大小
          };
  
        DATASETLOBBY.deleteFileByFileId(data).then((result) => {
          if (result.isSuccess) {
            // 关闭弹窗
            this.cancelPopup();
            this.$message.success(`已删除${this.modelTypeCompany(this.datasetType)}：` + file.fileName);
            this.getDatasetFileByDatasetId(this.Pictures.current);
          } else {
            this.$message.error(result.returnMsg);
          }
        })
      }
      // 批量删除/全部删除
      if (this.popupActive === 'batch_delete' || this.popupActive === 'all_delete') {
        let data = {
          datasetId: this.datasetId, // 数据集id
          datasetType: this.datasetType, // 数据集类型
          list: [], // 删除文件列表
          isAll: 0, // 是否全部删除：0为部分删除，1为全部删除
        };

        if (this.popupActive === 'batch_delete') {
          this.Pictures.records.forEach(item => {
            this.selectFileIdList.forEach(fileId => {
              if (fileId === item.fileId) {
                data.list.push({
                  fileId: item.fileId, // 文件id
                  fileSize: item.fileSize, // 文件大小
                })
              }
            });
          });
        }
        if (this.popupActive === 'all_delete') {
          data.isAll = 1
        }
  
        DATASETLOBBY.batchDeleteFile(data).then((result) => {
          if (result.isSuccess) {
            this.cancelPopup(); // 关闭弹窗
            this.$message.success(result.returnMsg);
            this.getDatasetFileByDatasetId(this.Pictures.current);
          } else {
            this.$message.error(result.returnMsg);
          }
        })
      }
    },

    // 图片重命名
    activeRenamePopup(obj, index) {
      this.popupActive = 'rename';
      this.popupData.rename.index = index;
      this.popupData.rename.fileId = obj.fileId;
      this.popupData.rename.fileName = obj.fileName;

    },
    // 确认重命名
    renameOperate() {
      if (!this.popupData.rename.fileName) {
        return this.$message.error('重命名不能为空');
      }
      if (this.popupData.rename.fileName.length > 20) {
        return this.$message.error('重命名不能超过20个字符');
      }

      let renameIndex = this.popupData.rename.index,
        fileId = this.popupData.rename.fileId,
        fileName = this.popupData.rename.fileName,
        data = {
          datasetId: this.datasetId, // 数据集id
          datasetType: this.datasetType, // 数据集类型
          fileId: fileId, // 文件id
          fileName: fileName // 文件名称
        },
        list = [];

      DATASETLOBBY.updateFileNameByFileId(data).then((result) => {
        if (result.isSuccess) {
          list = JSON.parse(JSON.stringify(this.Pictures.records));
          list[renameIndex].fileName = fileName;
          this.Pictures.records = list;
          this.cancelPopup(); // 关闭弹窗
          this.$message.success(result.returnMsg);
        } else {
          this.$message.error(result.returnMsg);
        }
      })
    },

    //  取消弹窗
    cancelPopup() {
      this.popupActive = "";
    },
    // 图片翻页
    handleCurrentChange(current) {
      this.initialState() // 变量初始状态
      this.getDatasetFileByDatasetId(current);
    },
  },
}
</script>

<style lang="scss" scoped>
div {
  box-sizing: border-box;
}
::v-deep.el-checkbox__input.is-checked .el-checkbox__inner,
::v-deep.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #4C88FF;
  border-color: #4C88FF;
}
.dataset-file-list {
  width: 100%;
  height: 100%;
  background: #FFFFFF;
  box-shadow: 0px 2px 6px 0px rgba(210,216,230,0.6);
  .list-head {
    width: 100%;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    border-bottom: 1px solid #E6E9F2;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    padding: 0 20px;
    ::v-deep.el-checkbox__label {
      color: #4C88FF;
      padding-left: 5px;
    }
    .add-button {
      display: flex;
    }
    span {
      // color: #4c88ff;
      color: #4C88FF;
      margin-left: 12px;
      cursor: pointer;
    }
    .el-button {
      height: 30px;
      background: #4C88FF;
      border: 1px solid #4C88FF;
      border-radius: 6px;
    }
  }

  .picture-box {
    min-height: 500px;
    background-color: #fff;
    position: relative;
    padding: 20px 0 80px;
    .pictures {
      display: flex;
      flex-wrap: wrap;
      .no-data {
        color: rgb(145, 144, 144);
        width: 300px;
        height: 160px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 134px;
          height: 80px;
        }
        span {
          color: #BDC3D2;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          margin-top: 16px;
        }
      }
      .picture-item {
        overflow: hidden;
        position: relative;
        // width: 225px;
        width: 18%;
        margin-left: 20px;
        .preview-icon {
          font-weight: 700;
          position: absolute;
          top: 10px;
          right: 10px;
          z-index: 1;
          cursor: pointer;
        }
        .el-icon-full-screen {
          color: #676767;
        }
        .icon-see-img,
        .icon-caret-preview {
          width: 17px;
          height: 17px;
          background: url("../../../assets/images/datasetLobby/icon-see-img.png") no-repeat;
          background-size: 100% 100%;
        }
        .icon-caret-preview {
          background: url("../../../../public/images/icon-play.png") no-repeat;
          background-size: 100% 100%;
        }
        figure {
          overflow: hidden;
          width: 100%;
          height: 140px;
          padding: 0;
          margin: 0;
          text-align: center;
          background-color: #e4e8f2;
          &:hover + .btns {
            visibility: visible;
            opacity: 1;
          }
          img {
            height: 100%;
            display: inline-block;
          }
          .img-top {
            height: 120px;
            padding-top: 10px;
          }
        }
        // .imageSizeText {
        //   color: #ccc;
        //   position: absolute;
        //   left: 8px;
        //   bottom: 55px;
        //   display: flex;
        //   span:last-child {
        //     margin-left: 10px;
        //   }
        // }
        .checkbox {
          position: absolute;
          left: 8px;
          bottom: 55px;
        }
        .btns {
          visibility: hidden;
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          box-sizing: border-box;
          // width: 80px;
          height: 140px;
          padding: 28px 72.5px 0;
          margin: 0 auto;
          background-color: rgba(8, 16, 44, 0.7);
          opacity: 0;
          @include transition;
          button {
            width: 80px;
            height: 36px;
            padding: 0;
            border: 0 none;
            outline: 0 none;
            border-radius: 3px;
            margin-bottom: 15px;
            text-align: center;
            line-height: 36px;
            cursor: pointer;
          }
          .btn-delete {
            background-color: $bgc_btn_del_1;
            &:hover {
              background: $bgc_btn_del_1_hover;
            }
            &:active {
              background-color: $bgc_btn_del_1;
            }
          }
          .btn-primary {
            color: $font_white;
            background-color: #4c88ff;
          }
          &:hover {
            visibility: visible;
            opacity: 1;
          }
        }
        .title {
          margin: 0 1.5em 10px;
          text-align: center;
          line-height: 40px;
        }
      }
    }

    .pagination {
      position: absolute;
      right: 0;
      bottom: 0;
      padding: 20px 0;
    }
  }
  
  // 弹窗
  .popup-list {
    .popup-delete,
    .popup-rename,
    .popup-upload-tip {
      &.off {
        display: none;
      }
    }
    .popup-delete {
      &::v-deep .popup-head {
        border-bottom: 0 none;
      }
      .popup-del-cnt {
        overflow: hidden;
        margin-top: -25px;
        .head {
          .icon-box {
            display: inline-block;
            margin-right: 12px;
            vertical-align: middle;
          }
          .title {
            display: inline-block;
            color: #333;
            vertical-align: middle;
          }
        }
        .content {
          padding: 15px 0;
          text-align: center;
        }
      }
    }

    .popup-delete-2 {
      &::v-deep .popup-inner {
        width: 420px;
        height: 200px;
      }
      .popup-del-cnt {
        margin-top: 10px;
        .head {
          text-align: center;
         }
      }
    }
  }
}
</style>
